import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import PagePagePC from './PagePagePC';
import PagePage from '../../common/models/PagePage';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import Button from 'flarum/components/Button';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import sortTags from 'flarum/tags/common/utils/sortTags';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import FloatPostButton from '../../common/components/FloatPostButton';
import NavigationBar from './NavigationBar';
import DiscussionPage from 'flarum/common/components/DiscussionPage';
import LogInModal from 'flarum/forum/components/LogInModal';
import Component from 'flarum/common/Component';
//主页
export default class TagsNav extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  title() {
    return <h4 className="App-titleControl tagTitle">{listItems(this.items().toArray())}</h4>;
  }

  items() {
    const items = new ItemList();
    items.add(
      'title',
      <div className="dl-header-tabs">
        <NavigationBar />
      </div>
    );

    return items;
  }

  view() {
    return this.title();
  }
}
